
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tours/[vDestinationSlug]/[slug-id]",
      function () {
        return require("private-next-pages/tours/[vDestinationSlug]/[slug-id]/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tours/[vDestinationSlug]/[slug-id]"])
      });
    }
  